import { AxiosResponse } from 'axios';
import { Result } from '../../models/common/resultResponse';
import {
  UserHierarchyFilterRequest,
  SaveUserHierarchyRequest,
  AvailableUsersForHierarchyRequest,
  DeleteUserHierarchyRequest,
  UpdateUserHierarchyRequest
} from '../../models/request/userHierarchyRequest';
import {
  UserHierarchyTreeResponse,
  AvailableUsersHierarchyResponse
} from '../../models/response/userHierarchyResponse';
import { PaginationResponse } from '@/main/models/common/paginationResponse';
import { KeyValue } from '@/main/models/common';

export abstract class IUserHierarchyApi {
  abstract getHierarchyTree(
    filter: UserHierarchyFilterRequest
  ): Promise<AxiosResponse<Result<UserHierarchyTreeResponse[]>>>;

  abstract saveHierarchyTree(
    request: SaveUserHierarchyRequest
  ): Promise<AxiosResponse<Result<any>>>;

  abstract getAvailableUsersForHierarchy(
    request: AvailableUsersForHierarchyRequest
  ): Promise<
    AxiosResponse<PaginationResponse<AvailableUsersHierarchyResponse[]>>
  >;

  abstract deleteHierarchyTree(
    request: DeleteUserHierarchyRequest
  ): Promise<AxiosResponse<Result<any>>>;

  abstract putHierarchyTree(
    request: UpdateUserHierarchyRequest
  ): Promise<AxiosResponse<Result<any>>>;

  abstract getLevelHierarchy(guidInsurer: string, idSystemApplication: number): Promise<AxiosResponse<KeyValue>>;
}
